import { Component, OnInit, Input } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.pug',
  styleUrls: ['./report-summary.component.scss'],
  standalone: false
})
export class ReportSummaryComponent implements OnInit {
  @Input() questionnaire: any;
  @Input() reportData: any;
  moment: any;
  lastActivityDate: any;
  statusColour = '';
  statusIcon: 'success' | 'fail' | 'warning' | null = null;

  constructor() { }

  ngOnInit(): void {
    this.lastActivityDate = moment(this.reportData?.check_exit_details.last_activity_date, 'YYYY-MM-DD');

    this.lastActivityDate = this.lastActivityDate.format('ll');

    if (this.reportData?.status) {
      this.setStatusColour(this.reportData.status);
    }
    if (this.reportData.report?.skill_score) {
      this.reportData.report.skill_score = this.reportData.report.skill_score.toFixed(1);
    }
    if (this.reportData.report?.competency_score) {
      this.reportData.report.competency_score = this.reportData.report.competency_score.toFixed(1);
    }
  }

  setStatusColour(status: string) {
    if (status === 'Submitted' || status === 'Verified') {
      this.statusColour = 'green';
      if (status === "Verified") {
        this.statusIcon = "success";
      }
    }
    else if (status === 'In progress') {
      this.statusColour = 'yellow';
    }
    else if (status === 'Declined') {
      this.statusColour = 'red';
      this.statusIcon = "fail";
    }
    else if (status === 'Invited') {
      this.statusColour = 'grey';
    }
  }
}
